import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const orderTutorial = (id, buttonText) => [
  {
    element: '.order_shortcut',
    intro: 'Dla tych opcji również stworzysz skrót'
  },
  {
    element: '.order_layers_direction',
    intro: `Tutaj zmienisz kolejność warstw na mapie, rządzisz!. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
